import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "header md:!tw-right-[-13px]" }
const _hoisted_2 = { class: "md:!tw-flex md:!tw-flex-col md:!tw-gap-[.5rem]" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", { class: "md:!tw-mb-0 md:!tw-text-[24px]" }, "iknowa Courses", -1)
const _hoisted_4 = { class: "trade_passport_preview_modal_title md:!tw-mb-0 md:!tw-text-[18px]" }
const _hoisted_5 = { class: "trade_passport_preview_modal_text md:!tw-mb-0 md:!tw-text-[12px] md:!tw-leading-[18px] md:!tw-min-h-[unset]" }
const _hoisted_6 = { class: "tw-w-full tw-min-h-[160px] tw-max-h-[160px] tw-overflow-hidden tw-rounded-[10px] rmd:!tw-min-h-[220px] rmd:!tw-max-h-[220px]" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "tw-w-full tw-flex tw-flex-col tw-gap-3" }
const _hoisted_9 = { class: "carousel-controls !tw-w-full tw-flex tw-flex-col !tw-gap-3 rmd:!tw-grid rmd:!tw-grid-cols-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_carousel_item = _resolveComponent("v-carousel-item")!
  const _component_v_carousel = _resolveComponent("v-carousel")!
  const _component_Button = _resolveComponent("Button")!
  const _component_CommonDialog = _resolveComponent("CommonDialog")!

  return (_openBlock(), _createBlock(_component_CommonDialog, {
    isShowHeader: false,
    isShowBackButton: false,
    width: "912px",
    "max-width": "100%",
    height: "auto",
    className: [
      'trade_passport_preview_modal ',
      'md:!tw-h-auto md:!tw-overflow-[unset]',
    ]
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_btn, {
          icon: "mdi-close",
          onClick: $setup.onClickCloseButton
        }, null, 8, ["onClick"])
      ]),
      _createVNode(_component_v_carousel, {
        height: "auto",
        class: "md:!tw-h-auto",
        style: {"overflow":"initial"},
        "hide-delimiter-background": "",
        "show-arrows": false,
        continuous: false,
        modelValue: $setup.model,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.model) = $event))
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.items, (item, i) => {
            return (_openBlock(), _createBlock(_component_v_carousel_item, { key: i }, {
              default: _withCtx(() => [
                _createVNode(_component_v_sheet, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _hoisted_3,
                      _createElementVNode("div", _hoisted_4, _toDisplayString(item?.title), 1),
                      _createElementVNode("div", _hoisted_5, _toDisplayString(item?.description), 1),
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("img", {
                          class: "tw-w-full tw-object-cover tw-h-[160px] rmd:!tw-h-[220px]",
                          src: item.src
                        }, null, 8, _hoisted_7)
                      ])
                    ])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_Button, {
            variant: "secondary",
            label: "Previous",
            onClick: $setup.prevSlide,
            isActive: $setup.model !== 0
          }, null, 8, ["onClick", "isActive"]),
          _createVNode(_component_Button, {
            variant: "secondary",
            label: $setup.model === $setup.items.length - 1 ? 'Close' : 'Next',
            onClick: $setup.handleNextClick
          }, null, 8, ["label", "onClick"])
        ]),
        _createVNode(_component_Button, {
          label: "View Course Details",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.viewCourseDetails($setup.currentCourseSlideId)))
        })
      ])
    ]),
    _: 1
  }))
}